import { useTranslation } from '../../hooks';
// TODO: changel last 2 params to options object!
export function useI18nCmsField(field, variables, prefix = 'cms:') {
    // translation service
    const { t, i18n } = useTranslation();
    if (field === undefined || field?.length === 0) {
        return {};
    }
    // check if value exists, default to undefined
    const getValue = (i18nKey) => i18n.exists(i18nKey) ? t(i18nKey, variables ?? {}) : undefined;
    // get translation values that can be used as props
    const title = getValue(`${prefix}${field}.title`);
    const label = getValue(`${prefix}${field}.label`);
    const tooltipText = getValue(`${prefix}${field}.helptext`);
    const tooltipTextAdditional = getValue(`${prefix}${field}.helptextadditional`);
    const hintText = getValue(`${prefix}${field}.hinttext`);
    const props = {
        ...(title ? { title } : {}),
        ...(label ? { label } : {}),
        ...(tooltipText
            ? {
                tooltip: {
                    description: tooltipText || '',
                    additionalDescription: tooltipTextAdditional,
                    additionalTitle: tooltipTextAdditional
                        ? label?.replace(/(\.?\*?)$/g, '')
                        : undefined,
                },
            }
            : {}),
        ...(hintText ? { hinttext: hintText } : {}),
    };
    return props;
}
